import React from "react";
import { CContainer } from "@coreui/react";

export default function PlaceholderPage({ title }) {
  return (
    <CContainer className="px-4" style={{ marginTop: "120px", maxWidth: "720px" }}>
      <h2 className="mb-3">{title}</h2>
      <p className="text-body-secondary">Раздел в разработке.</p>
    </CContainer>
  );
}
